import { Controller } from "stimulus"
import axios from 'axios';
export default class extends Controller {

 static get targets() {
    return ["tableBody"];
  }
 
 connect(){ 


    let t = this; 
    axios.get('/notification_subscriptions')
       .then(function(response){
           t.tableBodyTarget.innerHTML = response.data;
         }).catch(function(err){
          //session expired most likely returning 406, reload page
    })
 }

 paginate(event){
  let t = this;
  t.findPage(event.target);
 }

 findPage(elem){
  let t = this;
  let path = elem.href || "/notification_subscriptions";
   axios.get(path)
    .then(function(response){
      t.tableBodyTarget.innerHTML = response.data;
    })
 }

  handleRemove(event){
    let t = this;
    $(event.target).closest('tr').fadeOut(250, function(){
       let active_elem = $('.pagination .active a').first();
       t.findPage(active_elem);
    });
  
  }


}